import React from "react";
import CssClasses from "./LeagueButton.css";
import SiteIcons from "../../../assets/fonts/site_icons/style.css";
import { ConvertEmmettSportIDToBetRadarID } from "../../../HOCs/Helpers/SportConverter";

import allSportsIcon from "../../../assets/images/icons/icon_all_sports.png";
import basketballIcon from "../../../assets/images/icons/icon_basketball.png";
import soccerIcon from "../../../assets/images/icons/icon_soccer.png";
import tennisIcon from "../../../assets/images/icons/icon_tennis.png";
import volleyballIcon from "../../../assets/images/icons/icon_volleyball.png";
import liwIcon from "../../../assets/images/icons/icon_liw.png";
import futsalIcon from "../../../assets/images/icons/icon_futsal.png";
import handballIcon from "../../../assets/images/icons/icon_handball.png";
import baseballIcon from "../../../assets/images/icons/icon_baseball.png";
import hockeyIcon from "../../../assets/images/icons/icon_hockey.png";
import badmintonIcon from "../../../assets/images/icons/icon_badminton.png";
import rugbyIcon from "../../../assets/images/icons/icon_rugby.png";
import footballIcon from "../../../assets/images/icons/icon_football.png";
import table_tennisIcon from "../../../assets/images/icons/icon_table_tennis.png";
import beach_volleyballIcon from "../../../assets/images/icons/icon_beach_volleyball.png";
import bowlsIcon from "../../../assets/images/icons/icon_bowls.png";
import dartsIcon from "../../../assets/images/icons/icon_darts.png";
import snookerIcon from "../../../assets/images/icons/icon_snooker.png";
import cricketIcon from "../../../assets/images/icons/icon_cricket.png";
import specialIcon from "../../../assets/images/icons/icon_special.png";

const LeagueButton = props => {
  let classes = [CssClasses.button];

  if (props.isActive) {
    classes.push(CssClasses.active);
  }

  return (
    <div
      onClick={() => {
        props.onButtonClicked(props.id);
      }}
      className={classes.join(" ")}
    >
      <div
        className={[
          CssClasses.flagImageBox,
          props.adjustTopMarginFlag ? CssClasses.adjustedMarginTopFlag : ""
        ].join(" ")}
      >
        {getRasterIcon(ConvertEmmettSportIDToBetRadarID(props.sportID))}
      </div>
      <div className={CssClasses.titleSection}>
        <div className={CssClasses.countryName}>
          {props.titleTournament !== ""
            ? props.titleCategory + " - " + props.titleTournament
            : props.titleCategory}
        </div>
      </div>
      <div className={CssClasses.countIndicatorBox}>
        {/* <span
          className={[
            SiteIcons.site_icon_radiate_left,
            CssClasses.radiateLeft
          ].join(" ")}
        /> */}
        <span
          className={[
            CssClasses.countNumber,
            props.adjustTopMarginFlag ? CssClasses.adjustedCountNumber : ""
          ].join(" ")}
        >
          {props.eventCount}
        </span>
        {/* <span
          className={[
            SiteIcons.site_icon_radiate_right,
            CssClasses.radiateRight
          ].join(" ")}
        /> */}
      </div>
      <div className={CssClasses.clearFix} />
    </div>
  );
};

const getRasterIcon = sportID => {
  switch (sportID) {
    case -10:
      return (
        <img src={allSportsIcon} alt="" className={CssClasses.rasterIcon} />
      );
    case 1:
      return <img src={soccerIcon} alt="" className={CssClasses.rasterIcon} />;
    case 2:
      return (
        <img src={basketballIcon} alt="" className={CssClasses.rasterIcon} />
      );
    case 3:
      return (
        <img src={baseballIcon} alt="" className={CssClasses.rasterIcon} />
      );
    case 4:
      return <img src={hockeyIcon} alt="" className={CssClasses.rasterIcon} />;
    case 5:
      return <img src={tennisIcon} alt="" className={CssClasses.rasterIcon} />;
    case 6:
      return (
        <img src={handballIcon} alt="" className={CssClasses.rasterIcon} />
      );
    case 12:
      return <img src={rugbyIcon} alt="" className={CssClasses.rasterIcon} />;
    case 16:
      return (
        <img src={footballIcon} alt="" className={CssClasses.rasterIcon} />
      );
    case 19:
      return <img src={snookerIcon} alt="" className={CssClasses.rasterIcon} />;
    case 20:
      return (
        <img src={table_tennisIcon} alt="" className={CssClasses.rasterIcon} />
      );
    case 21:
      return <img src={cricketIcon} alt="" className={CssClasses.rasterIcon} />;
    case 22:
      return <img src={dartsIcon} alt="" className={CssClasses.rasterIcon} />;
    case 23:
      return (
        <img src={volleyballIcon} alt="" className={CssClasses.rasterIcon} />
      );
    case 29:
      return <img src={futsalIcon} alt="" className={CssClasses.rasterIcon} />;
    case 31:
      return (
        <img src={badmintonIcon} alt="" className={CssClasses.rasterIcon} />
      );
    case 32:
      return <img src={bowlsIcon} alt="" className={CssClasses.rasterIcon} />;
    case 34:
      return (
        <img
          src={beach_volleyballIcon}
          alt=""
          className={CssClasses.rasterIcon}
        />
      );
    case 1000:
      return <img src={liwIcon} alt="" className={CssClasses.rasterIcon} />;
    default:
      return <img src={specialIcon} alt="" className={CssClasses.rasterIcon} />;
  }
};

export default LeagueButton;



// WEBPACK FOOTER //
// ./src/Components/UI/LeagueButton/LeagueButton.js